import {EventBus} from "@/utilities/event-bus";
import { ModalIconType } from '@/components/system-modals/system-modals';
import { i18n } from "@/utilities/vue-i18n";

type InputDialogArgs = {
    title: string;
    message: string;
    placeholder?: string;
    warning?: string;
    validation?: (input: string) => boolean;
    initialInputData?: string;
    icon?: ModalIconType;
    inputType?: 'text' | 'password';
}

export async function inputDialogue(args: InputDialogArgs): Promise<{confirmed: true; input: string} | {confirmed: false}> {
    const {
        message,
        icon,
        title,
        initialInputData,
        placeholder,
        validation,
        warning,
        inputType,
    } = args;

    return new Promise<{confirmed: true; input: string} | {confirmed: false}>((resolve) => {
        EventBus.$emit('request-input', {
            title,
            message,
            placeholder,
            warning,
            inputType,
            validation,
            confirmCallback: (input: string) => resolve({confirmed: true, input: input}),
            initialInputData,
            cancelCallback: () => resolve({confirmed: false}),
            icon,
        });
    });
}

type InputDialogCallbackArgs = {
	title: string;
	message: string;
	placeholder?: string;
	warning?: string;
	validation?: (input: string) => boolean;
	confirmCallback: (input: string) => void;
	initialInputData?: string;
	cancelCallback: () => void;
	icon?: ModalIconType;
	inputType?: 'text' | 'password';
};

export function onInputDialogue(callback: (args: InputDialogCallbackArgs) => void) {

    EventBus.$on('request-input', (args: InputDialogCallbackArgs) => callback(args));
}

export async function alertDialogue(title: string, message: string, icon?: ModalIconType): Promise<void> {

    return new Promise<void>((resolve) => {

        EventBus.$emit('request-alert', {title, message, confirmCallback: () => resolve(), icon});
    });
}

export function onAlertDialogue(callback: (args: {title: string; message: string; confirmCallback: () => void; icon?: ModalIconType}) => void) {

    EventBus.$on('request-alert', (args: {title: string; message: string; confirmCallback: () => void; icon?: ModalIconType}) => callback(args));
}

export async function confirmDialogue(title: string, message: string, icon?: ModalIconType): Promise<boolean> {

    return new Promise<boolean>((resolve) => {

        EventBus.$emit('request-confirm', {title, message, confirmCallback: () => resolve(true), cancelCallback: () => resolve(false), icon});
    });
}

export function onConfirmDialogue(callback: (args: {title: string; message: string; confirmCallback: () => void; cancelCallback: () => void; icon?: ModalIconType}) => void) {

    EventBus.$on('request-confirm', (args: {title: string; message: string; confirmCallback: () => void; cancelCallback: () => void; icon?: ModalIconType}) => callback(args));
}

export const generalError = async (showIcon = true) => await alertDialogue(
    i18n.t('dialogue.error-general-title'),
    i18n.t('dialogue.error-general'),
    !showIcon ? undefined : ModalIconType.error);
